<div id="fakelayer_sidebar" class="modal-bg" (click)="trg_sidebar()"
	style="background: rgba(0,0,0,.3); z-index: 9999999; display: none;"></div>
<div id="master_sidebar" class="sidebar">
	<a (click)="trg_sidebar()"></a>
	
	<ul>
		<li><a (click)="navigate('home')">HOME</a></li>
		<li><a (click)="navigate('arena')">NOSSO ESPAÇO</a></li>
		<li><a (click)="navigate('modalities')">MODALIDADES</a></li>
		<li><a (click)="navigate('track')">O TREINO</a></li>
		<!-- <li><a (click)="navigate('agenda')">AGENDA</a></li>
		<li><a (click)="navigate('packages')">PACOTES</a></li> -->

		<li><a  
				(click)="goHaylie('regclick')"
				target="_blank"  
				href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre agendamentos na New Fit Performance Club"
				>AGENDA</a></li>
		<li><a  (click)="goHaylie('regclick')"
				target="_blank"  
				href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre os planos da New Fit Performance Club"
				>PACOTES</a></li>
		
		<li style="height: 54px"></li>
		<li></li>
		<li></li>
		<li><a (click)="navigate('modal-talk')">FALE CONOSCO</a></li>
		<li><a (click)="navigate('modal-partners')">PARCERIAS</a></li>
		<li><a (click)="navigate('modal-joinus')">TRABALHE CONOSCO</a></li>
	</ul>
	
	<br/>
	<a href="https://club.academianewfight.com.br" target="_blank"
		style="position: absolute; bottom: 7.77%; z-index: 999; display: block; 
				left: 50%; margin-left: -45px; opacity: .9;">
        <img class="octasvg" src="assets/logos/newfight/newfight-club-nf-120.png" 
					style="opacity: 1; width: 90px; margin-top: 3px;" />
    </a>

</div>